export interface TextNodeLike {
  nodeType: number;
  textContent: string | null;
  childNodes?: ArrayLike<TextNodeLike>;
  getAttribute?: (name: string) => string | null;
}

const TEXT_NODE = 3;
const ELEMENT_NODE = 1;
const COUNTER_CLASS = /^(badge|count|counter|n)$|^badge-|-(badge|count|counter|n)$/;

export function visibleText(node: TextNodeLike): string {
  return collect(node, true).replace(/\s+/g, ' ').trim();
}

function collect(node: TextNodeLike, root: boolean): string {
  if (node.nodeType === TEXT_NODE) return node.textContent ?? '';
  if (node.nodeType !== ELEMENT_NODE) return '';
  if (!root) {
    if (node.getAttribute?.('aria-hidden') === 'true') return '';
    if ((node.getAttribute?.('class') ?? '').split(/\s+/).some((name) => COUNTER_CLASS.test(name))) return '';
  }
  const children = node.childNodes ? Array.from(node.childNodes) : null;
  const text = children ? children.map((child) => collect(child, false)).join('') : (node.textContent ?? '');
  if (root) return text;
  return /^\s*\d+\s*$/.test(text) ? ' ' : ` ${text} `;
}

export { piiSelector } from './config';
